var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashBoardWww(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3171 23.6747C46.3171 36.2782 36.0864 46.5112 23.4806 46.5112C10.852 46.5112 0.644058 36.2782 0.644058 23.6747C0.644058 11.0666 10.852 0.838158 23.4806 0.838158C36.0864 0.838158 46.3171 11.0666 46.3171 23.6747ZM25.4902 32.3297C25.4902 33.4236 24.5768 34.3394 23.4806 34.3394C22.3844 34.3394 21.4938 33.4236 21.4938 32.3297L21.4938 22.236C21.4938 21.1376 22.3844 20.2492 23.4806 20.2492C24.5768 20.2492 25.4902 21.1376 25.4902 22.236L25.4902 32.3297ZM23.4578 12.9849C24.5767 12.9849 25.4674 13.8984 25.4674 14.9945C25.4674 16.0907 24.5767 16.9813 23.4806 16.9813C22.3616 16.9813 21.471 16.0907 21.471 14.9945C21.471 13.8984 22.3616 12.9849 23.4578 12.9849Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardWww);
export default __webpack_public_path__ + "static/media/dashBoard-www.e1cd3f0c8585aadc53e7e03b6ae6215b.svg";
export { ForwardRef as ReactComponent };